import{__awaiter as r}from"../../../../../node_modules/tslib/tslib.es6.js";import{shopifyStorefrontClientWrapper as e}from"../../../../../lib/clients.js";import{handleError as o}from"../../../../../lib/error-handler.js";import{gql as t}from"graphql-request";import{PRODUCT_PARAMS as s,PRODUCT_FRAGMENT as a}from"../../fragments/product.js";import{unlikelyProductInputToProductRequestParams as u}from"../../products/utils/unlikelyProductInputToProductRequestParams.js";import{SearchType as l}from"../../../../../types/shopify/storefront.js";import{serializeShopifySearchEntityFromTypename as i}from"../utils/serializers.js";import{PAGE_INFO_FRAGMENT as n}from"../../fragments/page-info.js";import d from"../../../../../lib/page-info.js";const c=t`
  query getSearchProductByQuery(
    $query: String!
    $first: Int!
    $after: String
    $before: String
    $last: Int
    $reverse: Boolean
    $sortKey: SearchSortKeys
    $unavailableProducts: SearchUnavailableProductsType
    $productFilters: [ProductFilter!]
    $language: LanguageCode
    $country: CountryCode
    ${s}
  ) @inContext(language: $language, country: $country) {
    search(
      query: $query
      first: $first
      after: $after
      before: $before
      last: $last
      reverse: $reverse
      sortKey: $sortKey
      unavailableProducts: $unavailableProducts
      productFilters: $productFilters
    ) {
      nodes {
        ... on Product {
          ${a}
        }
      }
      ${n}
      totalCount
    }
  }
`,f=e(((e,t)=>r(void 0,void 0,void 0,(function*(){var r,s,a,n;const f=yield e.request(c,Object.assign({query:t.query,first:t.first,types:l.Product,after:t.after,before:t.before,last:t.last,reverse:t.reverse,sortKey:t.sortKey,unavailableProducts:t.unavailableProducts,productFilters:t.productFilters,country:t.country,language:t.language},u(t)));return{errors:o(null==f?void 0:f.errors),products:(null===(r=null==f?void 0:f.search)||void 0===r?void 0:r.nodes)?f.search.nodes.flatMap(i):[],pageInfo:d(null===(s=null==f?void 0:f.search)||void 0===s?void 0:s.pageInfo),totalCount:null!==(n=null===(a=null==f?void 0:f.search)||void 0===a?void 0:a.totalCount)&&void 0!==n?n:0}}))));export{f as sfSearchProducts};
//# sourceMappingURL=searchProducts.js.map
